import { clinicalApiPath, viperApi } from '@/services/viper-api'
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import _ from 'lodash'

export const trialNotificationPreferencesService = {
  basePath: () =>
    `${clinicalApiPath}/organizations/${MyActiveOrganization.id}/trial-notification-preferences`,

  get() {
    return _.isNil(MyActiveOrganization.id) ? null : viperApi.get(this.basePath())
  },

  create(preferences) {
    return viperApi.post(this.basePath(), preferences)
  },

  update(preferences) {
    return viperApi.put(this.basePath(), preferences)
  }
}
